import methods from '../methods'

const API_URL = '/api'

const getTopics = () => methods.GET_API(`${API_URL}/topics`)

export default {
  getTopics
}
